import { useCallback, useEffect, useRef } from "react";
import { DiscussionObjectTypeConstants } from "src/constants";

import { useDiscussionsBase, UseDiscussionsBaseResult } from "../../widget/DiscussionsPanel/useDiscussionsBase";
import { buildCreateThreadParams, fetchTargetOrgUuids } from "./utils/taskDiscussionUtils";

export type UseTaskDiscussionsResult = UseDiscussionsBaseResult;

export const useTaskDiscussions = (taskUuid: string | undefined): UseTaskDiscussionsResult => {
  const targetOrgsRef = useRef<string[] | null | undefined>(undefined);

  useEffect(() => {
    targetOrgsRef.current = undefined;
  }, [taskUuid]);

  const resolveTargetOrganisationUuids = useCallback(async (objectUuid: string, currentOrganisationUuid: string) => {
    if (targetOrgsRef.current === undefined) {
      targetOrgsRef.current = await fetchTargetOrgUuids(objectUuid, currentOrganisationUuid);
    }
    return targetOrgsRef.current;
  }, []);

  const buildCreateRequest = useCallback(
    async (content: string, objectUuid: string, currentOrganisationUuid: string) => {
      const targets = await resolveTargetOrganisationUuids(objectUuid, currentOrganisationUuid);
      return buildCreateThreadParams(objectUuid, content, currentOrganisationUuid, targets);
    },
    [resolveTargetOrganisationUuids]
  );

  return useDiscussionsBase({
    objectUuid: taskUuid,
    objectType: DiscussionObjectTypeConstants.WORKFLOW_TASK,
    buildCreateRequest,
    resolveTargetOrganisationUuids,
  });
};
